var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForConnectingV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 432,
    viewBox: "0 0 420 432",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2770_96012)"
  }, /*#__PURE__*/React.createElement("pattern", {
    id: "dotPattern",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    fill: "currentColor",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("rect", {
    width: 432,
    height: 420,
    transform: "translate(420) rotate(90)",
    fill: "url(#dotPattern)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2770_96012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 432,
    height: 420,
    fill: "currentColor",
    transform: "translate(420) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForConnectingV2);
export default __webpack_public_path__ + "static/media/for-connecting-v2.70be1cb839befa8b38a73e3a1514b4ef.svg";
export { ForwardRef as ReactComponent };